/* tslint:disable */
/* eslint-disable */
/**
 * Guarantees API
 * Référentiel des garanties, rattachées aux branches
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateGarantieReferentielCommand,
  ErrorResponse,
  GarantieReferentielDto,
  OperationResponse,
  SearchGarantiesReferentielCommand,
  SearchGarantiesReferentielResponse,
  UpdateGarantieReferentielCommand,
} from '../models/index';
import {
    CreateGarantieReferentielCommandFromJSON,
    CreateGarantieReferentielCommandToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GarantieReferentielDtoFromJSON,
    GarantieReferentielDtoToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    SearchGarantiesReferentielCommandFromJSON,
    SearchGarantiesReferentielCommandToJSON,
    SearchGarantiesReferentielResponseFromJSON,
    SearchGarantiesReferentielResponseToJSON,
    UpdateGarantieReferentielCommandFromJSON,
    UpdateGarantieReferentielCommandToJSON,
} from '../models/index';

export interface CreateReferentialGuaranteeRequest {
    createGarantieReferentielCommand: CreateGarantieReferentielCommand;
}

export interface DeleteReferentialGuaranteeRequest {
    garantieId: string;
}

export interface GetGuaranteesByBranchRequest {
    brancheId: string;
}

export interface GetReferentialGuaranteeRequest {
    garantieId: string;
}

export interface SearchReferentialGuaranteesRequest {
    searchGarantiesReferentielCommand: SearchGarantiesReferentielCommand;
}

export interface UpdateReferentialGuaranteeRequest {
    garantieId: string;
    updateGarantieReferentielCommand: UpdateGarantieReferentielCommand;
}

/**
 * 
 */
export class GuaranteesApi extends runtime.BaseAPI {

    /**
     * Créer une garantie dans le référentiel
     */
    async createReferentialGuaranteeRaw(requestParameters: CreateReferentialGuaranteeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createGarantieReferentielCommand'] == null) {
            throw new runtime.RequiredError(
                'createGarantieReferentielCommand',
                'Required parameter "createGarantieReferentielCommand" was null or undefined when calling createReferentialGuarantee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/referentiel/garanties`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateGarantieReferentielCommandToJSON(requestParameters['createGarantieReferentielCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Créer une garantie dans le référentiel
     */
    async createReferentialGuarantee(requestParameters: CreateReferentialGuaranteeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createReferentialGuaranteeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Supprimer une garantie du référentiel
     */
    async deleteReferentialGuaranteeRaw(requestParameters: DeleteReferentialGuaranteeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['garantieId'] == null) {
            throw new runtime.RequiredError(
                'garantieId',
                'Required parameter "garantieId" was null or undefined when calling deleteReferentialGuarantee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/garanties/{garantieId}`.replace(`{${"garantieId"}}`, encodeURIComponent(String(requestParameters['garantieId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Supprimer une garantie du référentiel
     */
    async deleteReferentialGuarantee(requestParameters: DeleteReferentialGuaranteeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteReferentialGuaranteeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Garanties d\'une branche
     */
    async getGuaranteesByBranchRaw(requestParameters: GetGuaranteesByBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GarantieReferentielDto>>> {
        if (requestParameters['brancheId'] == null) {
            throw new runtime.RequiredError(
                'brancheId',
                'Required parameter "brancheId" was null or undefined when calling getGuaranteesByBranch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/garanties/branches/{brancheId}`.replace(`{${"brancheId"}}`, encodeURIComponent(String(requestParameters['brancheId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GarantieReferentielDtoFromJSON));
    }

    /**
     * Garanties d\'une branche
     */
    async getGuaranteesByBranch(requestParameters: GetGuaranteesByBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GarantieReferentielDto>> {
        const response = await this.getGuaranteesByBranchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Détail d\'une garantie du référentiel
     */
    async getReferentialGuaranteeRaw(requestParameters: GetReferentialGuaranteeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GarantieReferentielDto>> {
        if (requestParameters['garantieId'] == null) {
            throw new runtime.RequiredError(
                'garantieId',
                'Required parameter "garantieId" was null or undefined when calling getReferentialGuarantee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/garanties/{garantieId}`.replace(`{${"garantieId"}}`, encodeURIComponent(String(requestParameters['garantieId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GarantieReferentielDtoFromJSON(jsonValue));
    }

    /**
     * Détail d\'une garantie du référentiel
     */
    async getReferentialGuarantee(requestParameters: GetReferentialGuaranteeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GarantieReferentielDto> {
        const response = await this.getReferentialGuaranteeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Rechercher des garanties du référentiel
     */
    async searchReferentialGuaranteesRaw(requestParameters: SearchReferentialGuaranteesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchGarantiesReferentielResponse>> {
        if (requestParameters['searchGarantiesReferentielCommand'] == null) {
            throw new runtime.RequiredError(
                'searchGarantiesReferentielCommand',
                'Required parameter "searchGarantiesReferentielCommand" was null or undefined when calling searchReferentialGuarantees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/referentiel/garanties/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchGarantiesReferentielCommandToJSON(requestParameters['searchGarantiesReferentielCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchGarantiesReferentielResponseFromJSON(jsonValue));
    }

    /**
     * Rechercher des garanties du référentiel
     */
    async searchReferentialGuarantees(requestParameters: SearchReferentialGuaranteesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchGarantiesReferentielResponse> {
        const response = await this.searchReferentialGuaranteesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Modifier une garantie du référentiel
     */
    async updateReferentialGuaranteeRaw(requestParameters: UpdateReferentialGuaranteeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['garantieId'] == null) {
            throw new runtime.RequiredError(
                'garantieId',
                'Required parameter "garantieId" was null or undefined when calling updateReferentialGuarantee().'
            );
        }

        if (requestParameters['updateGarantieReferentielCommand'] == null) {
            throw new runtime.RequiredError(
                'updateGarantieReferentielCommand',
                'Required parameter "updateGarantieReferentielCommand" was null or undefined when calling updateReferentialGuarantee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/referentiel/garanties/{garantieId}`.replace(`{${"garantieId"}}`, encodeURIComponent(String(requestParameters['garantieId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateGarantieReferentielCommandToJSON(requestParameters['updateGarantieReferentielCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Modifier une garantie du référentiel
     */
    async updateReferentialGuarantee(requestParameters: UpdateReferentialGuaranteeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateReferentialGuaranteeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
